import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datetime';
import classNames from 'classnames';

class CalendarDatePicker extends PureComponent {
	/* eslint-disable-next-line react/destructuring-assignment */
	onClear = () => this.props.onChange(null)

	render() {
		const {
			value,
			onChange,
			onSelected,
			isClearable,
			name,
			isValidDate,
			datePickerSettings : {
				timeFormat,
				dateFormat,
				inputProps,
			},
		} = this.props;

		return (
			<div className="datepicker">
				<DateTimePicker
					timeFormat={timeFormat}
					dateFormat={dateFormat}
					inputProps={inputProps}
					name={name}
					value={value}
					onChange={onChange}
					onBlur={onSelected}
					isValidDate={isValidDate}
				/>
				<If condition={isClearable}>
					<span
						className={classNames('cursor-pointer', 'clear', {
							'rkf rkf-cross' : value,
							hidden          : !value,
						})}
						onClick={this.onClear}
						role="button"
						onKeyPress={null}
						tabIndex={0}
						aria-label="clear"
					/>
				</If>
			</div>
		);
	}
}

CalendarDatePicker.defaultProps = {
	value              : null,
	isClearable        : false,
	isValidDate        : undefined,
	onSelected         : () => {},
	datePickerSettings : {
		timeFormat : false,
		dateFormat : 'M/D/YYYY',
		inputProps : { readOnly : true },
	},
};

CalendarDatePicker.propTypes = {
	name               : PropTypes.string.isRequired,
	isValidDate        : PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
	value              : PropTypes.any,
	onSelected         : PropTypes.func,
	onChange           : PropTypes.func.isRequired,
	isClearable        : PropTypes.bool,
	datePickerSettings : PropTypes.shape({
		timeFormat : PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		dateFormat : PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		inputProps : PropTypes.object,
	}),
};

export default CalendarDatePicker;
